import React from 'react';
import FacetContainer from './facetContainer';
import RemoveIcon from '../../../../../../svg/icons/remove.svg';
import facetsStyles from './facets.module.pcss';
import { FacetData, MessageProperties } from '../../../../types';

interface FacetsProps {
  facets: FacetData[];
  messages: MessageProperties;
  clearFacetsHandler: () => void;
  facetsDisplayHandler: () => void;
  isDisabled: boolean;
}

function Facets({
  facets,
  messages,
  isDisabled,
  clearFacetsHandler,
  facetsDisplayHandler
}: FacetsProps): React.ReactElement {
  const styles = { ...facetsStyles };
  return (
    <div className={styles.facets}>
      <div tabIndex={-1} role="presentation" onClick={facetsDisplayHandler} className={styles['facets__close']} />
      <div className={styles['facets__body']}>
        <div className={styles['facets__top']}>
          <button
            type="button"
            disabled={isDisabled}
            onClick={facetsDisplayHandler}
            className={styles['facets__top-close']}
            aria-label={messages.closeLabel}
          >
            <RemoveIcon className={styles['facets__top-close-icon']} title={messages.closeIconLabel} />
          </button>
          <h2 className={styles['facets__top-title']}>{messages.title}</h2>
          <button
            type="button"
            disabled={isDisabled}
            onClick={clearFacetsHandler}
            className={styles['facets__top-clear']}
          >
            {messages.clearLabel}
          </button>
        </div>
        <ul className={styles['facets__list']}>
          {facets.map((facet) => (
            <li key={facet.code} className={styles['facets__list-item']}>
              <FacetContainer facet={facet} />
            </li>
          ))}
        </ul>
        <div className={styles['facets__bottom']}>
          <button type="button" disabled={isDisabled} onClick={facetsDisplayHandler} className="button--primary">
            {messages.viewLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Facets;
